import React, { useState, useEffect } from "react";
import { Skeleton } from "antd";
import { DeploymentUnitOutlined } from "@ant-design/icons";
import { dashboardData as dashboardService } from "../services/dashboardData";
/**
 * Shows platform-wide count of registered observability service configs
 * (backend field num_jobs = len(services) in DynamoDB) — not pipeline discovery count.
 */
const ResourceTrendChart = () => {
  const [configuredServices, setConfiguredServices] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await dashboardService.getAllAccountsDashboardData();
        setConfiguredServices(data.num_jobs ?? 0);
      } catch (error) {
        console.error("Error fetching service inventory:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div
        className="dashboard-home__inventory dashboard-home__inventory--loading"
        aria-busy="true"
        aria-label="Loading service inventory"
      >
        <Skeleton active title={{ width: "40%" }} paragraph={{ rows: 2, width: ["100%", "72%"] }} />
      </div>
    );
  }

  return (
    <div className="dashboard-home__inventory">
      <div className="dashboard-home__inventory-hero">
        <div className="dashboard-home__inventory-icon-wrap" aria-hidden>
          <DeploymentUnitOutlined />
        </div>
        <div className="dashboard-home__inventory-hero-text">
          <div className="dashboard-home__inventory-value">{configuredServices}</div>
          <div className="dashboard-home__inventory-caption">Configured services</div>
        </div>
      </div>
      <p className="dashboard-home__inventory-desc">
        Observability targets registered in the platform (all accounts). Pipeline totals on the KPI
        row above use discovery for the selected account.
      </p>
      <div className="dashboard-home__inventory-rule" aria-hidden />
      <div className="dashboard-home__inventory-footer">
        <span className="dashboard-home__inventory-footer-label">Scope</span>
        <span className="dashboard-home__inventory-footer-value">All accounts</span>
      </div>
    </div>
  );
};

export default ResourceTrendChart;
